import EventEmitter from 'eventemitter3';

export default class Emitter {
  static polyfill() {
    window.FND = window.FND || {};
    window.FND.common = window.FND.common || {};

    if (!window.FND.common.eventEmitter) {
      window.FND.common.eventEmitter = new EventEmitter();
    }

    return window.FND.common.eventEmitter;
  }
}
